export const extractSalesforceVisitorIdFromCookie = (): number | null => {
  const matchObj = document.cookie.match(/visitor_id[0-9]+=(?<id>[0-9]+)/);
  if (!matchObj) return null;
  const visitorId = Number(matchObj.groups?.id);
  return Number.isNaN(visitorId) ? null : visitorId;
};
